import { type ExamPreviewResultVariant } from '../components';
import {
  type QConfigStructure,
  type QConfigStructurePartResult,
  type QuestionGradingResult,
} from '../types';

export function mapStructureScores(
  structureScores: Record<string, QConfigStructurePartResult>,
  qConfigStructureParts: QConfigStructure[],
): {
  details: string;
  score: number;
  totalScore: number;
}[] {
  const orderedQConfigStructureParts = [...qConfigStructureParts].sort((a, b) => a.order - b.order);

  return orderedQConfigStructureParts.map((part) => ({
    details: part.name ?? '',
    score: structureScores[part.id]?.totalScore ?? 0,
    totalScore: structureScores[part.id]?.fullScore ?? 0,
  }));
}

export function mapQuestionGradingResults(questionGradingResults: QuestionGradingResult[]): {
  no: number;
  qid: string;
  scorePerQuestion: number;
  correctAnswer: string;
  selectedAnswer: string;
  result: ExamPreviewResultVariant;
}[] {
  return questionGradingResults
    .sort((a, b) => a.order - b.order)
    .map((q) => ({
      no: q.order,
      qid: q.questionMetadata.refCode as string,
      scorePerQuestion: q.fullScore,
      correctAnswer: q.correctAnswer,
      selectedAnswer: q.answer ?? '-',
      result: q.isCorrect ? 'passed' : 'failed',
    }));
}
